module.exports = {
    API_URL: 'http://csbsapiwebstaging-env.eba-6jesb3dr.eu-west-1.elasticbeanstalk.com',
    RAW_S3_STORAGE_URL: 'https://ktn-csbs-media.s3-eu-west-1.amazonaws.com',
    TINY_API_KEY: 'w8m7zdq0d2cveziquip80i2cam0pqj26j6nww7b8pzzdk7qk',
};
